__turbopack_context__.v({
  "contentsRoot": "JaPN0W_contentsRoot",
  "wrapper": "JaPN0W_wrapper",
});
